(function () {
  'use strict';

  function activateTab(root, nextName) {
    var tabs = root.querySelectorAll('[data-fs-tab]');
    var panels = root.querySelectorAll('[data-fs-panel]');

    tabs.forEach(function (tab) {
      var isActive = tab.getAttribute('data-fs-tab') === nextName;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.tabIndex = isActive ? 0 : -1;
    });

    panels.forEach(function (panel) {
      var isActive = panel.getAttribute('data-fs-panel') === nextName;
      if (isActive) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
  }

  function onClick(event) {
    var tab = event.target.closest('[data-fs-tab]');
    if (!tab) return;

    var root = tab.closest('[data-features-scenario]');
    if (!root) return;

    event.preventDefault();
    activateTab(root, tab.getAttribute('data-fs-tab'));
  }

  function onKeydown(event) {
    var tab = event.target.closest('[data-fs-tab]');
    if (!tab) return;

    var root = tab.closest('[data-features-scenario]');
    if (!root) return;

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-fs-tab]'));
    var index = tabs.indexOf(tab);
    if (index < 0) return;

    var nextIndex = index;
    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
      nextIndex = (index + 1) % tabs.length;
    } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
      nextIndex = (index - 1 + tabs.length) % tabs.length;
    } else if (event.key === 'Home') {
      nextIndex = 0;
    } else if (event.key === 'End') {
      nextIndex = tabs.length - 1;
    } else {
      return;
    }

    event.preventDefault();
    tabs[nextIndex].focus();
    activateTab(root, tabs[nextIndex].getAttribute('data-fs-tab'));
  }

  document.addEventListener('click', onClick);
  document.addEventListener('keydown', onKeydown);
})();
